<template>
    <div>
        <div class="row">
            <div class="col-12 mb-1">
                <b-form-checkbox v-model="value.MortgageIsActive">İpotek Durumu</b-form-checkbox>
            </div>
            <div class="col-md-4 mb-1">
                <label class="form-label">Banka</label>
                <v-select-list :disabled="!value.MortgageIsActive" v-model="bank" :options="banks" label="Name" placeholder="Banka"></v-select-list>
            </div>
            <div class="col-md-4 mb-1">
                <label class="form-label">Başlangıç Tarihi</label>
                <flat-pickr :disabled="!value.MortgageIsActive" v-model="value.MortgageStartDate" class="form-control" :config="{ altInput:true, altFormat:'d.m.Y',dateFormat: 'Y-m-d', locale:'tr'}" placeholder="Başlangıç Tarihi"/>
            </div>
            <div class="col-md-4 mb-1">
                <label class="form-label">Bitiş Tarihi</label>
                <flat-pickr :disabled="!value.MortgageIsActive || !value.MortgageStartDate" v-model="value.MortgageEndDate" class="form-control" :config="{ altInput:true, altFormat:'d.m.Y',dateFormat: 'Y-m-d', locale:'tr',minDate:value.MortgageStartDate}" placeholder="Bitiş Tarihi"/>
            </div>
        </div>
        <hr/>
        <div class="row">
            <div class="col-md-12 mb-1">
                <label class="form-label">Alış Fatura Tarihi</label>
                <flat-pickr v-model="value.InvoicePurchaseDate" class="form-control" :config="{ altInput:true, altFormat:'d.m.Y',dateFormat: 'Y-m-d', locale:'tr'}" placeholder="Alış Fatura Tarihi"/>
            </div>
            <div class="col-12">
                <div class="row">               
                    <div class="col-md-4 mb-1">
                        <label class="form-label">Kur Tarih</label>
                        <flat-pickr v-model="value.CurrencyDate" class="form-control" :config="{ altInput:true, altFormat:'d.m.Y',dateFormat: 'Y-m-d', locale:'tr'}" placeholder="Alış Fatura Tarihi"/>
                    </div>
                    <div class="col-md-4 mb-1">
                        <label class="form-label">Para Birimi</label>
                        <div class="row align-items-center">
                            <div class="col">
                                <v-select-list v-model="currency"  placeholder="Para Birimi" label="Name" :options="currencies"/>
                            </div>
                            <div class="col-auto">
                                <button :disabled="!value.AllowCurrencyRateChange || !currency" class="btn btn-icon btn-success" v-on:click="getCurrencyRate">
                                    <b-spinner small v-if="gettingCurrency"></b-spinner>
                                    <feather-icon v-else icon="RepeatIcon"></feather-icon>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4 mb-1">
                        <label class="form-label">Kur Oranı (TL)</label>
                        <input class="form-control" v-mask="currencyMask" :disabled="!value.AllowCurrencyRateChange" v-model="value.CurrencyRate" type="text" placeholder="Fiyat">
                    </div>
                </div>
            </div>
           
            
            <div class="col-md-6 mb-1">
                <label class="form-label">Fiyat {{c_currencyCode}}</label>
                <input class="form-control" v-mask="currencyMask" v-model="value.Price" type="text" placeholder="Fiyat">
            </div>
            
            <div class="col-md-6 mb-1">
                <label class="form-label">TL</label>
                <input class="form-control" v-mask="currencyMask"  disabled :value="value.ConvertedPrice" type="text" placeholder="Fiyat">
            </div>
        </div>
        <hr/>
        <div class="row">
            <div class="col-md-6 mb-1">
                <label class="form-label">Satın Alındığı Tarihteki KM</label>
                <input class="form-control" v-model="value.KmOnDateOfPurchase" type="number" placeholder="Satın Alındığı Tarihteki KM">
            </div>
        </div>
    </div>
</template>

<script>
import createNumberMask from 'text-mask-addons/dist/createNumberMask'
const currencyMask = createNumberMask({
    prefix: '',
    suffix: '',
    allowDecimal: true,
    includeThousandsSeparator: true,
    decimalSymbol:',',
    thousandsSeparatorSymbol:'.',
    allowNegative: false,
});
import {BFormCheckbox,BSpinner} from 'bootstrap-vue'
import flatPickr from 'vue-flatpickr-component'
import HumanResourcesParameterApi from '@/api/human-resources-parameters'
import SystemDataApi from '@/api/system-data'
import 'flatpickr/dist/l10n/tr.js'
import CurrencyApi from '@/api/currency'

export default{
    components:{
        BFormCheckbox,
        flatPickr,
        BSpinner
    },
    props:{
        value:Object,
    },
    data(){
        return{
            gettingCurrency:false,
            banks:[],
            currencies:[],
            currencyMask
        }
    },
    watch:{
        "value.Price"(){ this.convertPrice() },
        "value.CurrencyRate"(){ this.convertPrice() },
        "value.PurchaseCurrencyUnitId"(){ this.convertPrice() },
    },
    mounted(){
        this.getBanks()
        this.getCurrencies()
    },
    methods:{
        getBanks(){
            HumanResourcesParameterApi.Bank.List().then(res=>{
                this.banks = res.data.Data
            })
        },
        getCurrencies(){
            SystemDataApi.CurrencyUnit().then(res=>{
                this.currencies = res.data.Data
            })
        },
        convertPrice(){
            if(this.value.Price && this.value.CurrencyRate){
                this.value.ConvertedPrice = (parseFloat(this.value.Price?.toString().replaceAll('.','').replace(',','.')) * parseFloat(this.value.CurrencyRate?.toString().replaceAll('.','').replace(',','.')))?.toFixed(2).replaceAll('.',',')
            }
        },
        getCurrencyRate(){
            this.gettingCurrency = true
            CurrencyApi.GetInfoByDate({CurrencyDate:this.value.CurrencyDate,ToCurrencyCode:this.currency?.CurrencyCode}).then(res=>{
                if(res.data.Success){
                    this.value.CurrencyRate = res.data.Data
                }else {
                    this.$result(res)
                    this.value.CurrencyRate = null
                }
                this.gettingCurrency = false
            }).catch(err=>{
                this.$result(null,err)
                this.gettingCurrency = false
            })
        }
    },
    computed:{
        bank:{
            get:function(){
                return this.banks.find(b=>b.Id==this.value.MortgageBankId)
            },
            set:function(value){
                this.value.MortgageBankId = value?.Id || null
            }
        },
        currency:{
            get:function(){
                return this.currencies.find(b=>b.Id==this.value.PurchaseCurrencyUnitId)
            },
            set:function(value){
                this.value.PurchaseCurrencyUnitId = value?.Id || null
                if(value?.CurrencyCode == "TRY") {
                    this.value.CurrencyRate = "1,00"
                    this.value.AllowCurrencyRateChange =  false
                }else{
                    this.value.CurrencyRate = null
                    this.value.AllowCurrencyRateChange =  true
                }
            }
        },
        c_currencyCode(){
            if(this.currency) return ['(',this.currency.CurrencyCode,')'].join('')
            else return ''
        }
    }
}
</script>